import React, { createContext, useContext } from 'react';

export const UserContext = createContext(null);

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const dummyUser = { id: 1, role: 'staff' }; // 🔒 Replace with real auth later

  return (
    <UserContext.Provider value={dummyUser}>
      {children}
    </UserContext.Provider>
  );
};
